import { call, put, race, select, take, takeLatest, all } from 'redux-saga/effects'

import { REPLACE_STATE_ACTION } from '@/location'

import { toast } from '../../notifications'
import { newSearch } from '../../results/store/actions'
import { api } from '../../services'

import { loadSimilarJobs, loadSimilarJobsSuccess, loadSimilarJobsFailure } from './actions'
import { getSimilarJobsOffset, getSimilarJobsParams, getSelectedJobId } from './selectors'

const GENERIC_ERROR_MESSAGE = 'Es ist ein unbekannter Fehler aufgetreten.'

export function * requestSimilarJobs () {
  const { jobId, params, offset } = yield all({
    jobId: select(getSelectedJobId),
    params: select(getSimilarJobsParams),
    offset: select(getSimilarJobsOffset)
  })

  try {
    const {
      response,
      cancel
    } = yield race({
      response: call(api.search.similarJobs, jobId, { ...params, offset }),
      cancel: take([newSearch.trigger, REPLACE_STATE_ACTION])
    })
    if (!cancel) {
      const { status, data: { result, resultSize } } = response

      if (status === 200) {
        yield put(loadSimilarJobsSuccess({ result, resultSize }))
      } else {
        toast.error(GENERIC_ERROR_MESSAGE)
        yield put(loadSimilarJobsFailure({ message: GENERIC_ERROR_MESSAGE }))
      }
    }
  } catch (e) {
    toast.error(GENERIC_ERROR_MESSAGE)
    yield put(loadSimilarJobsFailure({ message: GENERIC_ERROR_MESSAGE }))
  }
}

export default all([
  takeLatest(loadSimilarJobs, requestSimilarJobs)
])
